export const QUERY_PARAMS = {
  CCODE: 'ccode',
  COLOR: 'color[]',
  DELIVERY_DATE: 'delivery_date',
  END_DATE: 'end_date',
  FLOWER_TYPE: 'flower_type[]',
  MCODE: 'mcode',
  OCCASION: 'occasion[]',
  PAGE: 'page',
  SORT: 'sort',
  START_DATE: 'start_date',
  AVAILABILITY_VERSION: 'availability_version',
  ZIP_CODE: 'zip_code',
};
